import { Http } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';
import { UtilsService } from './../../_services/utils.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/http";
import * as i2 from "@angular/common/http";
import * as i3 from "../../_services/utils.service";
import * as i4 from "@angular/router";
var DraftService = /** @class */ (function () {
    function DraftService(_http, http, _utilsService, router) {
        this._http = _http;
        this.http = http;
        this._utilsService = _utilsService;
        this.router = router;
        this.league_id = this.router.url.split('/')['5'];
        this.is_tournament = this.router.url.split('/')['6'];
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.currentUser != null) {
            this.user_id = this.currentUser.id;
        }
    }
    DraftService.prototype.getMessage = function (league_uuid, pageNo) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user_posts/get-draft-league-post/draft_user/' + league_uuid + '/all/' + pageNo, null, 'content-type-json');
    };
    DraftService.prototype.getScore = function (league_type, ignorelist, early, late) {
        var scorePost = { 'access_token': 'draft_user', 'sport': league_type, 'start': early, 'end': late, 'excluded': ignorelist };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/scores/get-scores', scorePost, null, 'content-type-json');
    };
    DraftService.prototype.getLeagueRecord = function (draft_id, uuid, is_tournament, round, draft_no) {
        if (is_tournament === "" + environment.tournament) {
            return this._utilsService.getRequest("" + environment.phpApiUrl + '/tournament/get-lg-detail/draft_user/' + draft_id + '/' + uuid + '/' + round + '/' + draft_no);
        }
        else {
            return this._utilsService.getRequest("" + environment.phpApiUrl + '/fantasyLeague/get-detail/draft_user/' + draft_id + '/' + uuid);
        }
    };
    DraftService.prototype.getSliderData = function (league_id) {
        var url = "" + environment.draftUrl + '/getSlider/' + league_id;
        return this.http.get(url, {
            headers: new HttpHeaders({}),
            responseType: 'blob'
        })
            .pipe(map(function (res) { return res; }));
    };
    DraftService.prototype.getQueueData = function (lgm_id) {
        var url = "" + environment.draftUrl + '/getQueue/' + lgm_id;
        return this.http.get(url, {
            headers: new HttpHeaders({}),
            responseType: 'blob'
        })
            .pipe(map(function (res) { return res; }));
    };
    DraftService.prototype.addToQueue = function (lgm_id, player_id) {
        return this._utilsService.getRequest("" + environment.draftUrl + '/addToQueue/' + lgm_id + '/' + player_id);
    };
    DraftService.prototype.removeFromQueue = function (lgm_id, player_id) {
        return this._utilsService.getRequest("" + environment.draftUrl + '/removeFromQueue/' + lgm_id + '/' + player_id);
    };
    DraftService.prototype.adjustQueue = function (lgm_id, isFirst, isLast, insertBefore, player_id) {
        return this._utilsService.getRequest("" + environment.draftUrl + '/adjustQueue/' + lgm_id + '/' + isFirst + '/' + isLast + '/' + ((insertBefore == null) ? 0 : insertBefore) + '/' + player_id);
    };
    DraftService.prototype.getPlayerData = function (lg_id, game_id, season_id, event_type_id, myteam_id, page, egs, lgs, duration_id, league_status) {
        var url = environment.boxScoreUrl + "/getPlayers/" + lg_id + "/" + game_id + "/" + season_id + "/" + event_type_id + "/" + myteam_id + "/" + page + "/" + egs + "/" + lgs + "/" + duration_id + "/" + league_status;
        return this.http.get(url, {
            headers: new HttpHeaders({}),
            responseType: 'blob'
        })
            .pipe(map(function (res) { return res; }));
    };
    DraftService.prototype.getDraftData2 = function (league_id, user_id) {
        return this._utilsService.getRequest("" + environment.boxScoreUrl + '/getDraftData2/' + league_id + '/' + user_id);
    };
    DraftService.prototype.getPlayerTable = function (lg_id, game_id, season_id, event_type_id, myteam_id, page, egs, lgs, duration_id) {
        var url = '';
        if (duration_id == 5) {
            url = environment.phpApiUrl + "/league/playoffPlayer/" + environment.DRAFT_ACCESS_TOKEN + "/" + lg_id + "/" + game_id + "/" + season_id + "/" + event_type_id + "/" + myteam_id + "/" + page;
        }
        else if (duration_id == 8) {
            url = environment.phpApiUrl + "/league/bestBallPlayer/" + environment.DRAFT_ACCESS_TOKEN + "/" + lg_id + "/" + game_id + "/" + season_id + "/" + event_type_id + "/" + myteam_id + "/" + page;
        }
        else {
            url = environment.phpApiUrl + "/league/players/" + environment.DRAFT_ACCESS_TOKEN + "/" + lg_id + "/" + egs + "/" + lgs + "/" + game_id + "/" + myteam_id + "/" + page;
        }
        return this._utilsService.getRequest(url);
    };
    DraftService.prototype.getLeaguePlayers = function (draft_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/league-member/get-list/draft_user/' + draft_id);
    };
    DraftService.prototype.createObservable = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.observer = observer;
        });
    };
    DraftService.prototype.unfollowMember = function (user_id, league_id) {
        var scorePost = { 'access_token': 'draft_user', 'user_id': user_id, 'league_id': league_id };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/league-member/unfollow', scorePost, null, 'content-type-json');
    };
    DraftService.prototype.getTournamentGroupRound = function (tournament_id, round_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/tournaments/get-group-rounds/draft_user/' + tournament_id + '/' + round_id);
    };
    DraftService.prototype.checkDraftAgain = function (league_id, user_id) {
        return this._utilsService.getRequest("" + environment.boxScoreUrl + '/checkDraftAgain/' + league_id + '/' + user_id);
    };
    DraftService.prototype.getTeamListForSlider = function (team_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/players/draft_player_list/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + team_id);
    };
    // remove data from local storage
    DraftService.prototype.removePlayerData = function (pkey) {
        var plyData = JSON.parse(localStorage.getItem('player_data'));
        if (plyData != null) {
            var index = plyData.findIndex(function (x) { return x.key == pkey; });
            if (index > -1) {
                plyData.splice(index, 1);
                localStorage.setItem('player_data', JSON.stringify(plyData));
            }
        }
    };
    DraftService.prototype.errorLog = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user/angular-error-log', data);
    };
    DraftService.prototype.getPositionBG = function (position) {
        var colors = {
            'QB': '#bac9e2',
            'RB': '#bae2ba',
            'WR': '#e2e1ba',
            'TE': '#e2baba',
            'DEF': '#bae2e0',
            'K': '#d8bae2',
            'FLEX': 'rgba(146, 134, 44, 0.60)',
            'C': 'rgba(207, 93, 41, 0.30)',
            'LW': 'rgba(72, 175, 23, 0.30)',
            'RW': 'rgba(207, 189, 22, 0.30)',
            'D': 'rgba(71, 170, 162, 0.30)',
            'G': 'rgba(189, 23, 23, 0.30)',
            '1B': 'rgba(84, 45, 224, 0.30)',
            '2B': 'rgba(72, 179, 23, 0.30)',
            '3B': 'rgba(207, 189, 22, 0.30)',
            'SS': 'rgba(223, 27, 27, 0.30)',
            'LF': 'rgba(32, 180, 155, 0.30)',
            'CF': 'rgba(155, 32, 167, 0.30)',
            'RF': 'rgba(187, 38, 120, 0.30)',
            'SP': 'rgba(76, 153, 147, 0.30)',
            'TG': 'rgba(74, 79, 136, 0.30)',
            'BN': 'rgba(58, 131, 119, 0.30)',
            'IR': 'rgba(51, 109, 63, 0.30)',
            'W': 'rgba(167, 94, 46, 0.30)',
            'F': 'rgba(150, 56, 90, 0.30)',
            'S': 'rgba(54, 131, 33, 0.30)',
            'MI': 'rgba(60, 82, 54, 0.30)',
            'OF': 'rgba(148, 77, 139, 0.30)',
            'DH': 'rgba(97, 42, 56, 0.30)',
            'UTIL': 'rgba(70, 148, 148, 0.30)',
            'P': 'rgba(101, 131, 76, 0.30)',
            'RP': 'rgba(120, 155, 39, 0.30)',
            'PG': 'rgba(136, 34, 34, 0.30)',
            'FG': 'rgba(104, 134, 28, 0.30)',
            'SG': '#8ae06b',
            'SF': 'rgba(37, 50, 172, 0.30)',
            'PF': 'rgba(106, 39, 131, 0.30)',
            'IF': 'rgba(52, 235, 235, 0.30)',
            'WR-TE': 'rgba(255, 118, 20, 0.50)',
            'SFLEX': 'rgba(179, 162, 211, 0.50)',
            'default': '#ddd'
        };
        if (typeof colors[position] !== 'undefined') {
            return colors[position];
        }
        else {
            return 'rgba(173, 188, 230, 0.50)';
        }
    };
    DraftService.prototype.handleError = function (error) {
        console.error('server error: ', error);
        if (error.error instanceof Error) {
            var errMessage = error.error.message;
            return Observable.throw(errMessage);
        }
        return Observable.throw(error || 'Socket.io server error');
    };
    DraftService.prototype.handleErrorPost = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            console.error(result); // log to console instead 
            // TODO: better job of transforming error for user consumption
            console.log(operation + " failed: " + error.message);
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    DraftService.ngInjectableDef = i0.defineInjectable({ factory: function DraftService_Factory() { return new DraftService(i0.inject(i1.Http), i0.inject(i2.HttpClient), i0.inject(i3.UtilsService), i0.inject(i4.Router)); }, token: DraftService, providedIn: "root" });
    return DraftService;
}());
export { DraftService };
